// Angular Import
import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavigationComponent {
  // public props
  windowWidth = window.innerWidth;
  @Output() NavMobCollapse = new EventEmitter();

  // public method
  navMobCollapse() {
    if (this.windowWidth < 992) {
      // Sumit changes
      // this.NavMobCollapse.emit();
    }
  }
}
